var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__cardmap"},[_c('div',{staticClass:"container__cardmap__gmap"},[_c('CardMapRelatorio')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }